export default {
  data: () => ({
    syncronizedQueryParameters: []
  }),

  created() {
    for (const p of this.syncronizedQueryParameters) {
      this.updateComponentValueFromQueryParam(p.valueKey, p.queryKey, p.forceArray)
      this.$watch(p.valueKey, this.updateQueryParameters)
    }
  },

  methods: {
    updateComponentValueFromQueryParam(valueKey, queryKey, forceArray = false) {
      let queryParams = JSON.parse(JSON.stringify(this.$route.query))
      let queryValue = queryParams.hasOwnProperty(queryKey) ? queryParams[queryKey] : null
      if (!!this[valueKey] && queryValue) {
        if (forceArray) queryValue = typeof queryValue === 'Array' ? queryValue : [queryValue]
        this[valueKey] = queryValue
      }
    },

    updateQueryParameters() {
      const query = this.syncronizedQueryParameters
        .reduce((acc, param) => {
          if (this[param.valueKey].length > 0) {
            acc[param.queryKey] = this[param.valueKey]
          }
          return acc
        }, {})
      this.$router.replace({ path: '', query })
    }
  }
}
